import React from "react";
import PropTypes from "prop-types";

interface BreadcrumbItem {
  displayName: string;
  onClick: () => void;
  shorten?: boolean;
}

interface BreadcrumbProps {
  path: BreadcrumbItem[];
  className?: string;
}

class Breadcrumb extends React.Component<BreadcrumbProps> {
  static propTypes = {
    path: PropTypes.arrayOf(
      PropTypes.shape({
        displayName: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        shorten: PropTypes.bool,
      })
    ).isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: "",
  };

  render() {
    const { path, className } = this.props;

    return (
      <nav className={`m-breadcrumbs ${className}`}>
        <ul className="m-breadcrumbs__trail">
          {path.map((item, index) => (
            <li
              key={index}
              className={`m-breadcrumbs__item ${
                index === path.length - 1 ? "m-breadcrumbs__item--active" : ""
              }`}
            >
              <a
                href="#"
                className="m-breadcrumbs__link"
                style={
                  index === path.length - 1
                    ? { cursor: "default", pointerEvents: "none" }
                    : undefined
                }
                onClick={(e) => {
                  e.preventDefault();
                  item.onClick();
                }}
              >
                {item.shorten && item.displayName.length > 20
                  ? `${item.displayName.substring(0, 20)}...`
                  : item.displayName}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    );
  }
}

export default Breadcrumb;
